export enum GroupsEnum {
    CORRECTOR = 'corrector',
    EXAM_CENTER_BOSS = 'exam_center_boss',
    STAFF = 'staff',
    STUDENT = 'student',
    SUPERVISOR = 'supervisor',
}